import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EmojiPickerService } from '@components/emoji-picker/emoji-picker.service';
import { FuiBadgeComponent } from '@fui/fui-components';
import { TableCellListComponent } from './list-cell/list-cell.component';

/**
 * Кастомизации рендера ячеек в табличном движке для определённых типов данных.
 * Ожидается, что любая кастомщина для ячеек с определёнными типами данных перекочует в этот модуль.
 */
@NgModule({
    declarations: [TableCellListComponent],
    exports: [TableCellListComponent],
    providers: [EmojiPickerService],
    imports: [CommonModule, FuiBadgeComponent],
})
export class TableCellsModule {}
